/**
 * Per-procedure benefit selection types, stored on `benefitsForProvProc.benefitSelectionType`
 * inside the order's serviceDetails JSON. Mirrors `ProvProcBenefitSelectionType` in
 * services/clear-api/src/domains/orders/orders.dto.ts.
 */
export const benefitSelectionTypes = {
  SELF_PAY: "SELF_PAY",
  // CLE-2659: priced identically to SELF_PAY, but also requires an ABN signature at checkout.
  SELF_PAY_WITH_ABN: "SELF_PAY_WITH_ABN",
  COINSURANCE_APPLIES: "COINSURANCE_APPLIES",
  PREVENTIVE: "PREVENTIVE",
  REQUIRES_ABN: "REQUIRES_ABN",
} as const;

/** Selections that price the procedure as self-pay — patient owes the full amount, no insurance applied. */
export const isSelfPayBenefit = (
  benefitSelectionType?: string | null
): boolean =>
  benefitSelectionType === benefitSelectionTypes.SELF_PAY ||
  benefitSelectionType === benefitSelectionTypes.SELF_PAY_WITH_ABN;

/** Selections that require the patient to sign an ABN before checkout can continue. */
export const requiresAbnSignature = (
  benefitSelectionType?: string | null
): boolean =>
  benefitSelectionType === benefitSelectionTypes.REQUIRES_ABN ||
  benefitSelectionType === benefitSelectionTypes.SELF_PAY_WITH_ABN;
